module.exports = __webpack_public_path__ + "img/nutrition-1.aecf9002.png";